module.exports = __webpack_public_path__ + "img/5.ee5e2a79.png";